"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _ = require("../..");
var _utils = require("../../../utils");
var _utils2 = require("./utils");
var _types = require("../../../types");
var _PawssSection = require("./PawssSection");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var AssessmentSurvey = function AssessmentSurvey(_ref) {
  var _intakeData$patientSu;
  var patientId = _ref.patientId,
    isPatientStateActive = _ref.isPatientStateActive,
    surveyData = _ref.surveyData,
    intakeData = _ref.intakeData,
    historyOfIllness = _ref.historyOfIllness,
    expanded = _ref.expanded,
    onClickDetail = _ref.onClickDetail;
  var survey = surveyData.survey,
    patientSurvey = surveyData.patientSurvey,
    patientSurveyAnswers = surveyData.patientSurveyAnswers;
  var assessmentAnswer = (0, _lodash.find)(patientSurveyAnswers, function (_ref2) {
    var question = _ref2.question;
    return (question === null || question === void 0 ? void 0 : question.name) === _utils.ASSESSMENT_QUESTION_NAME;
  });
  var assessmentSubmitted = (patientSurvey === null || patientSurvey === void 0 ? void 0 : patientSurvey.status) === _types.SurveyStatuses.Finished;
  var medicationsQuery = assessmentSubmitted ? "?endDate=".concat(patientSurvey === null || patientSurvey === void 0 ? void 0 : patientSurvey.submittedAt) : '';
  var _useFetch = (0, _utils.useFetch)("".concat((0, _utils.getPatientPrescriptionsUrl)(patientId)).concat(medicationsQuery), []),
    medications = _useFetch.data,
    loadingMedications = _useFetch.loading,
    refetchMedications = _useFetch.refetch;
  (0, _react.useEffect)(function () {
    if (assessmentSubmitted) {
      refetchMedications();
    }
  }, [assessmentSubmitted]);
  var CollapsedStateRenderer = /*#__PURE__*/_react.default.createElement("div", {
    className: "text-black tw-body-light"
  }, assessmentSubmitted ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loadingMedications
  }, /*#__PURE__*/_react.default.createElement("p", null, "Prescriptions:", ' ', !loadingMedications && (0, _lodash.isEmpty)(medications) ? 'No prescription created before submission.' : medications.map(function (_ref3) {
    var displayName = _ref3.displayName;
    return displayName;
  }).join(', '))), assessmentAnswer && /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-[16px]"
  }, /*#__PURE__*/_react.default.createElement(_.Question, {
    question: assessmentAnswer.question,
    answer: assessmentAnswer
  }))) : /*#__PURE__*/_react.default.createElement("p", null, "The ", (0, _utils.getRoleNameLower)(_utils.UserRoles.Doctor), " has not yet completed the assessment."));
  var patientAnswers = intakeData === null || intakeData === void 0 ? void 0 : (_intakeData$patientSu = intakeData.patientSurvey) === null || _intakeData$patientSu === void 0 ? void 0 : _intakeData$patientSu.patientAnswers;
  var prescriptionWarning = (0, _utils.getAnswerByQuestionName)(patientAnswers, _utils.PREGNANT_OR_BREASTFEEDING_QUESTION_NAME) === _utils.YES_ANSWER;
  var QuestionRenderer = function QuestionRenderer(questionProps) {
    var question = questionProps.question;
    if (question.name === _utils.PRESCRIPTIONS_QUESTION_NAME) {
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_.QuestionText, null, "Prescriptions"), isPatientStateActive && /*#__PURE__*/_react.default.createElement(_.OpenErx, {
        disabled: true,
        patientId: patientId,
        withMedications: true,
        hideButtonWhenDisabled: true,
        medicationsQuery: medicationsQuery,
        onClose: refetchMedications,
        confirmPrompt: prescriptionWarning ? 'I acknowledge this member has reported they are breastfeeding and I have assessed the risk of this member.' : ''
      }), question.note && /*#__PURE__*/_react.default.createElement("p", {
        className: "tw-body-light"
      }, question.note));
    }
    if (question.name === _utils.CPT_CODE_QUESTION_NAME) {
      return /*#__PURE__*/_react.default.createElement(_.CptCodeQuestion, _extends({}, questionProps, {
        name: "cptCode",
        disabled: true
      }));
    }
    if (question.name === _utils.ICD_CODE_QUESTION_NAME) {
      return /*#__PURE__*/_react.default.createElement(_.IcdCodeQuestion, _extends({}, questionProps, {
        name: "icdCodes",
        disabled: true
      }));
    }
    if (question.name === _utils.HISTORY_OF_ILLNESS_QUESTION_NAME) {
      return /*#__PURE__*/_react.default.createElement(_.Question, _extends({}, questionProps, {
        defaultValue: historyOfIllness
      }));
    }
    if (question.name === _utils.PATIENT_WAS_INFORMED_QUESTION_NAME) {
      var answers = (0, _utils2.getAnswersForAttestationQuestion)(question, medications);
      if (!answers) {
        return;
      }
      return /*#__PURE__*/_react.default.createElement(_.Question, _extends({}, questionProps, {
        question: _objectSpread(_objectSpread({}, question), {}, {
          answers: answers
        })
      }));
    }
  };
  return /*#__PURE__*/_react.default.createElement(_.PatientSurvey, {
    title: "".concat((0, _utils.getRoleName)(_utils.UserRoles.Doctor), " Assessment"),
    surveyData: surveyData,
    expanded: expanded,
    CollapsedStateRenderer: CollapsedStateRenderer,
    onClickDetail: onClickDetail
  }, (survey === null || survey === void 0 ? void 0 : survey.sections) && (0, _lodash.map)(survey.sections, function (questions, sectionName) {
    return /*#__PURE__*/_react.default.createElement(_.SurveySection, {
      key: sectionName
    }, sectionName === 'PAWSS' ? /*#__PURE__*/_react.default.createElement(_PawssSection.PawssSection, {
      sectionName: sectionName,
      questions: questions,
      patientSurveyAnswers: patientSurveyAnswers,
      intakeData: intakeData
    }) : questions.map(function (question) {
      var answer = (0, _.getAnswerForQuestion)(question, patientSurveyAnswers);
      return /*#__PURE__*/_react.default.createElement(_.Question, {
        key: question.id,
        question: question,
        answer: answer,
        QuestionRenderer: QuestionRenderer
      });
    }));
  }));
};
var _default = AssessmentSurvey;
exports.default = _default;